import React from "react";
import { object, array, string, bool } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import PublishedAt from "../../atoms/PublishedAt";
import StoryMetaData from "../../molecules/StoryMetaData";

import { getHeadline, getExcerpt } from "../../utils/utils";

import "./customStoryCard9.m.css";

const CustomStoryCard9 = ({
  story,
  className = "",
  aspectRatio = [3, 2],
  imageType = "image3x2",
  isNotification,
  pageType,
  updatedFont = false,
  publisherLang = ""
}) => {
  const storyHeadline = getHeadline(story);
  const pageTypes = ["author-page", "tag-page", "search-page", "section-page"];
  const excerpt = pageTypes.includes(pageType) ? getExcerpt(story) : null;
  const storyHeadlineStyle = updatedFont ? `${publisherLang}-story-headline` : "";
  const storyExcerptStyle = updatedFont ? `${publisherLang}-story-excerpt` : "";
  const storyBrief = () => {
    if (excerpt) {
      return excerpt;
    } else {
      if (story.subheadline) {
        return story.subheadline;
      } else {
        return null;
      }
    }
  };

  return (
    <div styleName="base" className={className}>
      <div styleName="wrapper">
        <div styleName="story-data">
          {isNotification && <PublishedAt date={story["last-published-at"]} className="notification-storydate" />}
          {pageType === "search-page" && story.subheadline && (
            <Headline text={story.subheadline} headerLevel={4} headlineType={6} className="sub-headline--mobile" />
          )}
          <Link href={story.url}>
            <Headline
              text={storyHeadline}
              headerLevel={2}
              headlineType={27}
              className="story-headline"
              styleName={storyHeadlineStyle}
            />
          </Link>
          {pageType === "search-page" && excerpt && (
            <Headline text={excerpt} headerLevel={4} headlineType={6} className="excerpt" />
          )}
          {storyBrief() && pageType !== "search-page" && (
            <Headline
              text={storyBrief()}
              headerLevel={4}
              headlineType={6}
              className={`sub-headline ${excerpt ? "excerpt" : ""}`}
              styleName={storyExcerptStyle}
            />
          )}
          <StoryMetaData story={story} />
        </div>
        <Link href={story.url}>
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={[250]}
            showAlternateImage={true}
          />
        </Link>
      </div>
    </div>
  );
};
CustomStoryCard9.propTypes = {
  story: object.isRequired,
  className: string,
  aspectRatio: array,
  imageType: string,
  isNotification: bool,
  isAuthor: bool,
  pageType: string,
  updatedFont: bool,
  publisherLang: string
};

const mapStateToProps = state => ({
  pageType: get(state, ["qt", "pageType"], null)
});

export default connect(mapStateToProps, null)(CustomStoryCard9);
